/** Names and help text for where a column can go, shared by the column list and the zones. */

import type { SelectOption } from "@/components/ui/select";
import type { Slot, Target } from "../csv-mapping";

export const TARGET_LABEL: Record<Target, string> = {
  input: "Input",
  expected_output: "Expected output",
  output: "Output",
  metadata: "Metadata",
  key: "Item key",
  skip: "Skip",
};

export const TARGET_OPTIONS: SelectOption[] = (Object.keys(TARGET_LABEL) as Target[]).map((t) => ({
  value: t,
  label: TARGET_LABEL[t],
  hint: t === "key" ? "metadata.key" : undefined,
}));

export const SLOT_HINT: Record<Slot, string> = {
  input: "Required. What the agent gets: each column is a field.",
  expected_output: "Optional. The answer you expect. One column is the value itself; several make an object.",
  output: "Optional. Answers the agent already gave, scored without running it.",
  metadata: "Optional. Kept with the item, not sent to the agent. A column named key is the item id.",
};

/** The drag payload type, so a dropped file or text from elsewhere is ignored. */
export const DRAG_TYPE = "application/x-csv-column";
